import { FC } from 'react';

import { BottomSliderControlled } from 'components/_basic/BottomSlider';
import { AIAssistantAlertCard } from 'components/BusinessToolForm/components/AIAssistantAlertCard';

import { IAIGenerationErrorModalParentProps } from './types';
import { AIGenerationErrorModal } from '../AIGenerationErrorModal/AIGenerationErrorModal';

export const AIGenerationErrorModalParent: FC<IAIGenerationErrorModalParentProps> = ({ close, errorMessage }) => {
  return (
    <>
      <BottomSliderControlled
        renderController={(onClick) => (
          <AIGenerationErrorModal
            click={onClick}
            errorMessage={errorMessage}
            close={() => {
              close();
            }}
          />
        )}
      >
        {({ onClose }) => (
          <AIAssistantAlertCard
            onCardClose={() => {
              onClose();
              close();
            }}
          />
        )}
      </BottomSliderControlled>
    </>
  );
};
